import {
  TALENT_FILTERS_LOCAL_STORAGE,
  TALENT_QUICK_FILTER_LOCAL_STORAGE,
} from "../../talents/constants";
import { SearchFilter } from "../../../common/components/functional/FilterSearchField/FilterSearchField";
import { TalentQuickFilterButton } from "./types";

export const getFiltersFromLocalStorage = (): SearchFilter[] | null => {
  const value = localStorage.getItem(TALENT_FILTERS_LOCAL_STORAGE);
  return value ? JSON.parse(value) : null;
};

// TODO use FilterSearchField helpers instead
export const setFiltersToLocalStorage = (filters: SearchFilter[]) => {
  localStorage.setItem(TALENT_FILTERS_LOCAL_STORAGE, JSON.stringify(filters));
};

export const getQuickFilterFromLocalStorage = ():
  | TalentQuickFilterButton
  | "" => {
  const value = localStorage.getItem(TALENT_QUICK_FILTER_LOCAL_STORAGE);
  return (value as TalentQuickFilterButton) || "";
};

export const setQuickFilterToLocalStorage = (
  quickFilter: TalentQuickFilterButton,
) => localStorage.setItem(TALENT_QUICK_FILTER_LOCAL_STORAGE, quickFilter);

export const removeQuickFilterFromLocalStorage = () =>
  localStorage.removeItem(TALENT_QUICK_FILTER_LOCAL_STORAGE);
